import React from "react";
import { cn } from "../../utils/cn";
import {
  baseClasses,
  colorClasses,
  hoverColorClasses,
  hoverShadow,
  ButtonType,
} from "./buttonStyles";

interface ButtonProps {
  text: string;
  disabled?: boolean;
  color?: "peach";
  type?: ButtonType;
  className?: string;
  htmlButtonType?: "submit" | "button";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const Button: React.FC<ButtonProps> = ({
  text,
  disabled = false,
  color = "peach",
  type = "primary",
  className,
  htmlButtonType = "submit",
  onClick,
}) => {
  const classes = cn(
    baseClasses,
    colorClasses[color][type],
    className,
    disabled
      ? "cursor-default opacity-50"
      : cn("hover:cursor-pointer", hoverShadow, hoverColorClasses[color][type]),
  );

  return (
    <button
      className={classes}
      type={htmlButtonType}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;
